import Vue from 'vue'
import Vuex from 'vuex'
import adminApplications from './modules/admin-applications'
import adminCompanies from './modules/admin-companies'
import adminJobs from './modules/admin-jobs'
import app from './modules/app'
import applicationForm from './modules/application-form'
import charities from './modules/charities'
import companies from './modules/companies'
import companyForm from './modules/company-form'
import donationForm from './modules/donation-form'
import experience from './modules/experience'
import experienceForm from './modules/experience-form'
import jobForm from './modules/job-form'
import jobseekerForm from './modules/jobseeker-form'
import jobseekerProfiles from './modules/jobseeker-profiles'
import jobseekerReferral from './modules/jobseeker-referral'
import loginForm from './modules/login-form'
import notifications from './modules/notifications'
import referrals from './modules/referrals'
import profileForm from './modules/profile-form'
import hirerProfileForm from './modules/hirer-profile-form'
import signupForm from './modules/signup-form'
import skills from './modules/skills'
import statuses from './modules/status'
import jobReferral from './modules/job-referral'
import jobs from './modules/jobs'
import widget from './modules/widget'
import jobseekers from './modules/jobseekers'
import conversations from './modules/conversations'
import scatter from './modules/scatter'
import socket from './modules/socket'
import users from './modules/users'
import sigproviders from './modules/signature-providers'
import sessions from './modules/sessions'
import adminHirers from './modules/admin-hirers'
import hiredReferrals from './modules/hired-referrals'
import hirerForm from './modules/hirer-form'
import cvViewer from './modules/cv-viewer'
import wallet from './modules/wallet'
import walletTx from './modules/wallet-transactions'
import loading from './modules/loading-indicator'
import RegisterApply from './modules/register-apply'
import HirerProfile from './modules/hirer-profile'
import domain from './modules/domain'
import daoCommunity from './modules/dao-community'
import greenHouse from './modules/green-house'
import widgetStyles from './modules/widget-styles'
import lever from './modules/lever'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    appRoot: `${window.location.protocol}//${window.location.host}`
  },
  getters: {
    getJobseekerProfileLink: state => {
      return `${state.appRoot}/jobseekers`
    },
    getHirerProfileLink: state => {
      return `${state.appRoot}/hirer`
    }
  },
  mutations: {},
  actions: {},
  modules: {
    widgetStyles,
    greenHouse,
    lever,
    adminApplications,
    adminCompanies,
    adminJobs,
    app,
    applicationForm,
    charities,
    companies,
    companyForm,
    conversations,
    donationForm,
    experienceForm,
    experience,
    jobForm,
    jobReferral,
    jobs,
    widget,
    jobseekerForm,
    jobseekers,
    jobseekerProfiles,
    jobseekerReferral,
    loginForm,
    notifications,
    profileForm,
    hirerProfileForm,
    referrals,
    scatter,
    signupForm,
    socket,
    skills,
    statuses,
    users,
    sigproviders,
    sessions,
    adminHirers,
    hiredReferrals,
    hirerForm,
    cvViewer,
    wallet,
    walletTx,
    loading,
    RegisterApply,
    HirerProfile,
    domain,
    daoCommunity
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js